export function createTmsConf (envConf, user) {
    const that = this;
    // 使用运营工具sit环境进行测试
    const env = envConf.env === 'PROD' ? envConf.env.toLocaleLowerCase() : 'sit';
    return {
        env,
        lang: 'zh-CN',
        // classify: {
        //     oneClassifyCode: 'yyyw', // 填写自己项目的一级分类
        //     twoClassifyCode: 'yyyw_tms01', //  填写自己项目的二级分类
        //     threeClassifyCode: 'yyyw_tms01_a3' //  填写自己项目的三级分类
        // },
        userInfo: {
            token: that.itsmToken,
            user: user.userCode,
            appId: envConf.tmsItsmAppId,
            productId: 'f9a2e030-2575-4e4d-a483-d276f906f53f',
            systemId: '32cb09ef-e500-49ff-a991-f7b2d1363a82',
            messageSystem: 'C-TMS' // 接入我的消息系统
            // commonFieldList: [
            //     // { name: '客户订单号', value: 'K2J3K2J3K' }
            //     // { name: '公共字段4', value: '444' }
            // ]
        },
        componentBottom: 50,
        intimeevaluateUserInfo: {
            user_name: user.userName, // mip账号（姓名）
            user_id: that.contactsMobile || user.userCode // mip账号
        },
        intimeevaluateTempleteInfo: {
            terminal: 'PC',
            appType: 'pc', // 终端类型 pc、app
            modeType: 'hover', // 弹框挂件展示类型 hover: 挂件式
            business: '安得智联', // 领域 eg: 内销领域
            system: 'C-TMS', // 系统 eg: 美云销
            product: 'TMS运输管理系统', // 产品 eg: TPC交易与履约中心
            scene: 'C-TMS七月份版本V1页面右侧', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧 唯一标示 测试生产环境要对上
            primaryColor: '#00BCBF', // 提交按钮的主色调,默认：#0888ff
            hoverBtnColor: '', // 提交按钮在hover时候的颜色， 默认：#39a0ff
            hoverTagColor: '' // tag标签在hover时候的颜色 默认：#ebf5ff
        },
        tabs: [ // 菜单名称(最多4个)
            {
                unique: 'G5000',
                name: 'IT5000',
                icon: 'feedback-tool-filled',
                jumpUrl: ''
            },
            {
                unique: 'message',
                name: '我的消息',
                icon: 'feedback-message',
                jumpUrl: ''
            },
            {
                unique: 'advice',
                name: '我要建议',
                icon: 'feedback-edit-filledbeifen',
                jumpUrl: ''
            }
        ],
        whetherTheCoexistence: true, // 我要建议与我要评价是否共存
        // themeColor: '#00BCBF', // 主题颜色
        // tabsBackgroundColor: '#fff', // tabs背景色
        // unfoldColor: '#00BCBF', // 展开按钮颜色
        configInfo: {
            // version: 1, // 金融版本为1,不填为it5000版本
            // channelCode: 'C_TMS', // 渠道编码(接入金融版本联系产品获取)
            // mode: null, // 1:GPM系统,不传和为空都是默认模式
            // unfoldIcon: 'icon-edit-filled' // 展开按钮icon
            screenshotsMode: 2,
            isMobile: true,
            autoFillMobile: that.contactsMobile || null,
            isAdviceMobile: true, // 是否开启"我要反馈"的联系方式字段
            isRequiredAdviceMobile: false, // 我要反馈"的联系方式字段是否必填(配合isAdviceMobile使用)
            autoAdviceMobile: that.contactsMobile || null, // 自动填入"我要反馈"里的联系方式(配合isAdviceMobile使用)
        }
        // helpInfo: { // 帮助中心信息
        //     systemName: 'C-TMS', // 系统名称
        //     relateId: '0' // 文档id
        // }
    };
}
